/* eslint-disable */
import React, { useState } from 'react';
import NotificationService, { NotificationData } from 'src/services/notificationservice';
import {
  ModalBackdrop,
  ModalContainer,
  Header,
  Grid,
  Label,
  Input,
  Select,
  Footer,
  SaveButton,
  CloseButton,
  TextArea,
} from './styles';

interface NotificationModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit?: () => void; // made optional
}

const NotificationModal: React.FC<NotificationModalProps> = ({ open, onClose, onSubmit }) => {
  const [fields, setFields] = useState<NotificationData>({
    type: '',
    module: '',
    manager: 'Global',
    benefits: '',
  });

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  if (!open) return null;

  const updateField = (name: keyof NotificationData, value: string) => {
    setFields({ ...fields, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await NotificationService.createGlobalNotification(fields);
      setLoading(false);
      if (onSubmit) onSubmit();
      onClose();
    } catch (err) {
      setLoading(false);
      setError('Failed to save notification. Please try again.');
    }
  };

  return (
    <ModalBackdrop>
      <ModalContainer>
        <CloseButton aria-label="Close" onClick={onClose}>
          &times;
        </CloseButton>
        <Header>Add Notification</Header>
        <form onSubmit={handleSubmit}>
          <Grid>
            <div>
              <Label htmlFor="type-select">Type</Label>
              <Select
                id="type-select"
                value={fields.type}
                onChange={e => updateField('type', e.target.value)}
                disabled={loading}
              >
                <option value="Task">Task</option>
                <option value="Notification">Notification</option>
                <option value="Distribution">Distribution</option>
                <option value="New Hire">New Hire</option>
                <option value="Paystatements">Paystatements</option>
                <option value="W2 Forms">W2 Forms</option>
                <option value="Other">Other</option>
              </Select>
            </div>

            <div>
              <Label htmlFor="module-input">Message</Label>
              <TextArea
                id="module-input"
                placeholder="Enter module"
                value={fields.module}
                onChange={e => updateField('module', e.target.value)}
                disabled={loading}
              />
            </div>
          </Grid>
          {error && <div style={{ color: 'red', marginBottom: 8 }}>{error}</div>}
          <Footer>
            <SaveButton type="submit" disabled={loading}>
              {loading ? 'Saving...' : 'Save'}
            </SaveButton>
          </Footer>
        </form>
      </ModalContainer>
    </ModalBackdrop>
  );
};

export default NotificationModal;
